export default class ReportFiltersSelector {
  public static selectQuery(state: ReduxState) {
    return state.reportFilter.query;
  }
}
